import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NetworkService } from '../../core/services/network.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { CartService } from '../../core/services/cart.service';
import * as braintree from 'braintree-web';

declare const window: any;

@Component({
  selector: 'payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PaymentComponent implements OnInit {
  @ViewChild("paypal", {read: ElementRef}) paypalElement: ElementRef;

  token: string = '';
  hostedFieldsInstance: any;
  order: any;
  paymentMethod: string = 'paypal';
  isLoading: boolean;
  isOrderSuccess: boolean = false;
  errorMsg: string = '';

  isMethodsVisible: boolean = true;
  isPayPalRender: boolean = false;
  isHavePayPalRender: boolean;
  isCreditCardRender: boolean;
  isClickedNext: boolean = false;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private network: NetworkService,
    private cdRef: ChangeDetectorRef,
    private cartService: CartService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');

    if (this.token) {
      this.fetchData(this.token);
    }
  }

  fetchData(token) {
    this.network
      .fetchOrder(token)
      .then(order => {
        if (this.authenticationService.isAuthenticated()) {
          this.cartService.clearCart();
        }
        this.order = order;
      })
      .catch(err => {
        console.log(err);
      });
  }

  toPaymentMethod() {
    this.isClickedNext = true;
    this.isMethodsVisible = false;
    this.isLoading = true;
    this.errorMsg = '';

    this.network
      .getClientToken()
      .then(response => {
        this.isLoading = false;

        if (this.paymentMethod === 'bank_transfer') {
          this.makeBankTransfer();
        } else {
          this.connectBrainTree(response.token);
        }
      });
  }

  toChoosingMethod() {
    if (!this.isClickedNext) {
      this.router.navigate(['/cart']);
    }
    this.isClickedNext = false;
    this.isMethodsVisible = true;
    this.isPayPalRender = false;
    this.isCreditCardRender = false;
    this.isLoading = false;
  }

  connectBrainTree(clientToken: string) {
    const wrapMakeOrder = this.makeOrder.bind(this);

    switch (this.paymentMethod) {
      case 'paypal': {
        if (!this.isHavePayPalRender) {
          this.connectPayPal(clientToken, this.paymentMethod, wrapMakeOrder);
          this.isHavePayPalRender = true;
        }
        this.isPayPalRender = true;
        break;
      }
      case 'credit_card': {
        this.connectCreditCard(clientToken)
        this.isCreditCardRender = true;
        break;
      }
    }
    this.isLoading = false;
  }

  makeOrder(paymentType, paymentNonce) {
    this.isLoading = true;
    this.cdRef.detectChanges();
    this.makePayment(paymentNonce);
  }

  makePayment(paymentNonce) {
    const requestData = {
      payment_method: this.paymentMethod,
      data: {
        payment_method_nonce: paymentNonce
      }
    };

    this.hostedFieldsInstance = null;
    this.network.createPayment(this.token, requestData)
      .then(response => {
        this.isOrderSuccess = true;
        this.toChoosingMethod();
        this.cdRef.detectChanges();
      })
      .catch(error => {
        this.toChoosingMethod();

        if (error.error && error.error.message) {
          this.errorMsg = error.error.message;
        }

        this.cdRef.detectChanges();
      });
  }

  makeBankTransfer() {
    const requestData = {
      payment_method: this.paymentMethod,
      data: {
        payment_method_nonce: ''
      }
    };

    this.network.createPayment(this.token, requestData)
      .then(response => {
        this.isOrderSuccess = true;
        this.toChoosingMethod();
      })
      .catch(error => {
        this.toChoosingMethod();

        if (error.error && error.error.message) {
          this.errorMsg = error.error.message;
        }
      });
  }

  connectPayPal(clientToken: string, paymentType: string, orderCallBack: any) {
    const fetchOrder = () => this.network.fetchOrder(this.token)

    braintree.client.create({
      authorization: clientToken
    }).then(function (clientInstance) {
      return braintree.paypalCheckout.create({
        client: clientInstance
      });
    })
      .then(function (paypalCheckoutInstance) {
      return paypalCheckoutInstance.loadPayPalSDK({
        currency: 'EUR'
      });
    })
      .then(function (paypalCheckoutInstance) {
      return  fetchOrder().then((data) => {
       return window.paypal.Buttons({
          fundingSource: window.paypal.FUNDING.PAYPAL,
         style: {
           size: 'large',
           color: 'blue',
           shape: 'rect',
           label: 'paypal',
           tagline: 'false',
           height: 50
         },
          createOrder: function () {
            return paypalCheckoutInstance.createPayment({
              flow: 'checkout',
              currency: 'EUR',
              amount: data.total.raw
            });
          },

          onApprove: function (data, actions) {
            return paypalCheckoutInstance.tokenizePayment(data)
              .then(function (payload) {
                orderCallBack(paymentType, payload.nonce)
              });
          },

          onCancel: function (data) {
            console.log('PayPal payment cancelled', JSON.stringify(data, null, 2));
          },

          onError: function (err) {
            console.error('PayPal error', err);
          }

        }).render('#paypal-button');
      })
    }).then(function () {
      // The PayPal button will be rendered in an html element with the ID
      // `paypal-button`. This function will be called when the PayPal button
      // is set up and ready to be used.
    }).catch(function (err) {
      if (err) {
        console.error('Error creating client:', err);
        return;
      }
    });
  }

  connectCreditCard(clientToken: string) {
    braintree.client.create({
      authorization: clientToken
    }).then(clientInstance => braintree.hostedFields.create({
      client: clientInstance,
      styles: {
        'input': {
          'font-size': '18px'
        },
        '.valid': {
          'color': 'green',
          'font-weight': 'bold'
        },
        '.invalid': {
          'color': 'red',
          'font-weight': 'bold'
        }
      },
      fields: {
        number: {
          selector: '#card-number'
        },
        cvv: {
          selector: '#cvv'
        },
        expirationDate: {
          selector: '#expiration-date'
        },
      }
    })).then((hostedFieldsInstance) => this.hostedFieldsInstance = hostedFieldsInstance)
  }

  submitPaymentByCreditCard() {
    this.hostedFieldsInstance.tokenize().then((payload) => {
      return this.makeOrder(this.paymentMethod, payload.nonce)
    })
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/payment/payment.component.ts